export default "__VITE_ASSET__4ec5d7b8__"